import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/providers/general/general.service';

@Component({
  selector: 'app-sys-logs',
  templateUrl: './sys-logs.component.html',
  styleUrls: ['./sys-logs.component.scss']
})
export class SysLogsComponent implements OnInit {
  @Input() txnID: any;
  @Input() typeID: any;
  @Input() subTxnID: any;
  @Input() logs: any = [];
  @Input() tbl: any;
  public response: any = [];
  // public logs: any = [];
  constructor(private genralService: GeneralService) { }

  ngOnInit(): void {
    console.log('Transaction logs ', this.logs);
    setTimeout(() => {
    this.showLogs();
    }, 1000);
  }
  // tslint:disable-next-line: typedef
  showLogs() {
      this.genralService.getSysLogs(this.typeID, this.txnID, this.subTxnID, this.tbl).subscribe(res => {
        this.response = res;
        this.logs = this.response.data;
        console.log(this.logs);
       },
      err => {
      });
  }

}
